import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";

export default function Summary() {
  const userId = sessionStorage.getItem("userId")
  const navigate = useNavigate()

  const { data: getUserDetail, isLoading: loading } = useQuery({
    queryKey: ["getuserDetail", userId],
    queryFn: () => getRequest(`user/detail/${userId}`),
    enabled: Boolean(userId),
    onSuccess: (data) => {

    },
  });

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      // return postRequest("/user/createPaymentIntent", data);
      return postRequest("/transaction/createCheckoutSession", data);
    },
    // onSuccess: (data) => {
    //   if (data?.status === 200) {
    //     window.location.href = `${data?.link}`;
    //   }
    // },
    onSuccess: (data) => {
      const redirectUrl = data?.url;
      if (data?.status === 200) {
        if (redirectUrl && typeof redirectUrl === "string" && redirectUrl.trim() !== "") {
          window.location.href = redirectUrl;
        } else {
          navigate("/stripe-success");
        }
      }
    },

    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleSubscribe = () => {
    // const currentSubscriptionId = getUserDetail?.result?.subscriptionId?._id;
    // if (currentSubscriptionId && currentSubscriptionId === "6895808accb8fa6fd040e372") {
    //   navigate("/stripe-success");
    //   return;
    // }

    const payload = {
      userId: userId,
    };
    mutate(payload);

  }

  return (
    <>
      <section className="commn-bg-set">
        <div className="card-center-set">
          <div className="commn-card-theme">
            <img
              className="side-logo-set"
              src={require("../Assets/images/logo-main.png")}
            />
            <h2>Summary</h2>
            <p>Please check everything is correct</p>
            <div className="shop-detail-view pb-3">
              <h3>Your Details</h3>
              <p>
                {getUserDetail?.result?.firstName} {getUserDetail?.result?.surname}
                <br />
                {getUserDetail?.result?.email}
              </p>
              {/* <h3 className="mt-4">Your Chosen Store</h3>
              <p>
                {getUserDetail?.result?.preferedStoreId?.name}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.firstLine}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.secondLine}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.townORcity}
                <br />
                {getUserDetail?.result?.preferedStoreId?.address?.postcode}
              </p> */}
              <h3 className="mt-4">Your Subscription</h3>
              <p>
                {getUserDetail?.result?.subscriptionId?.title} Membership
                <br />
                £{getUserDetail?.result?.subscriptionId?.price} per month
                {/* <br />
                Includes 1 coﬀee per day at any Quaﬀee */}
                <br />
                {getUserDetail?.result?.subscriptionId?.description}
              </p>
              <div className="mt-4">
                <button
                  // onClick={() => Navigate(`/stripe-success?storeid=${storeid}`)}
                  onClick={() => handleSubscribe()}

                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
